import { COLOR_CODE, COLOR_NAME } from '@/constant';

/**
 * 色名をカラーコードに変換
 * @param {string} colorName 色名
 */
export function convertColorNameToColorCode(colorName: string) {
  if (typeof colorName !== 'string') return '';
  let color = '';
  switch (colorName) {
    case COLOR_NAME.PALE.GREY:
      color = COLOR_CODE.PALE.GREY;
      break;
    case COLOR_NAME.PALE.SCARLET:
      color = COLOR_CODE.PALE.SCARLET;
      break;
    case COLOR_NAME.PALE.LIGHT_BLUE:
      color = COLOR_CODE.PALE.LIGHT_BLUE;
      break;
    case COLOR_NAME.PALE.LIGHT_GREEN:
      color = COLOR_CODE.PALE.LIGHT_GREEN;
      break;
    case COLOR_NAME.PALE.PURPLE:
      color = COLOR_CODE.PALE.PURPLE;
      break;
    case COLOR_NAME.PALE.ORANGE:
      color = COLOR_CODE.PALE.ORANGE;
      break;
    case COLOR_NAME.PALE.BLUE:
      color = COLOR_CODE.PALE.BLUE;
      break;
    case COLOR_NAME.PALE.GREEN:
      color = COLOR_CODE.PALE.GREEN;
      break;
    case COLOR_NAME.PALE.MAGENTA:
      color = COLOR_CODE.PALE.MAGENTA;
      break;
    case COLOR_NAME.PALE.YELLOW:
      color = COLOR_CODE.PALE.YELLOW;
      break;
    case COLOR_NAME.PALE.BLUE_VIOLET:
      color = COLOR_CODE.PALE.BLUE_VIOLET;
      break;
    case COLOR_NAME.PALE.CYAN:
      color = COLOR_CODE.PALE.CYAN;
      break;
    case COLOR_NAME.PALE.RED:
      color = COLOR_CODE.PALE.RED;
      break;
    case COLOR_NAME.PALE.CORAL:
      color = COLOR_CODE.PALE.CORAL;
      break;
    case COLOR_NAME.PALE.DODGER_BLUE:
      color = COLOR_CODE.PALE.DODGER_BLUE;
      break;
    case COLOR_NAME.PALE.SEA_GREEN:
      color = COLOR_CODE.PALE.SEA_GREEN;
      break;
    case COLOR_NAME.PALE.VIOLET:
      color = COLOR_CODE.PALE.VIOLET;
      break;
    case COLOR_NAME.PALE.GOLD:
      color = COLOR_CODE.PALE.GOLD;
      break;
    case COLOR_NAME.PALE.NAVY:
      color = COLOR_CODE.PALE.NAVY;
      break;
    case COLOR_NAME.PALE.TURQUOISE:
      color = COLOR_CODE.PALE.TURQUOISE;
      break;
    case COLOR_NAME.PALE.PINK:
      color = COLOR_CODE.PALE.PINK;
      break;
    case COLOR_NAME.PALE.GREEN_YELLOW:
      color = COLOR_CODE.PALE.GREEN_YELLOW;
      break;
    case COLOR_NAME.PALE.INDIGO:
      color = COLOR_CODE.PALE.INDIGO;
      break;
    case COLOR_NAME.PALE.SKY_BLUE:
      color = COLOR_CODE.PALE.SKY_BLUE;
      break;
    case COLOR_NAME.PALE.SALMON:
      color = COLOR_CODE.PALE.SALMON;
      break;
    case COLOR_NAME.STRONG.STEEL_GREY:
      color = COLOR_CODE.STRONG.STEEL_GREY;
      break;
    case COLOR_NAME.STRONG.SEPIA:
      color = COLOR_CODE.STRONG.SEPIA;
      break;
    case COLOR_NAME.STRONG.BROWN:
      color = COLOR_CODE.STRONG.BROWN;
      break;
    case COLOR_NAME.STRONG.MAROON:
      color = COLOR_CODE.STRONG.MAROON;
      break;
    case COLOR_NAME.STRONG.PURPLE:
      color = COLOR_CODE.STRONG.PURPLE;
      break;
    case COLOR_NAME.STRONG.PANSY:
      color = COLOR_CODE.STRONG.PANSY;
      break;
    case COLOR_NAME.STRONG.SAXE_BLUE:
      color = COLOR_CODE.STRONG.SAXE_BLUE;
      break;
    case COLOR_NAME.STRONG.ORIENTAL_BLUE:
      color = COLOR_CODE.STRONG.ORIENTAL_BLUE;
      break;
    case COLOR_NAME.STRONG.COBALT_BLUE:
      color = COLOR_CODE.STRONG.COBALT_BLUE;
      break;
    case COLOR_NAME.STRONG.CERULEAN_BLUE:
      color = COLOR_CODE.STRONG.CERULEAN_BLUE;
      break;
    case COLOR_NAME.STRONG.ROYAL_BLUE:
      color = COLOR_CODE.STRONG.ROYAL_BLUE;
      break;
    case COLOR_NAME.STRONG.MARINE_BLUE:
      color = COLOR_CODE.STRONG.MARINE_BLUE;
      break;
    case COLOR_NAME.STRONG.MALACHITE_GREEN:
      color = COLOR_CODE.STRONG.MALACHITE_GREEN;
      break;
    case COLOR_NAME.STRONG.GREEN:
      color = COLOR_CODE.STRONG.GREEN;
      break;
    case COLOR_NAME.STRONG.EMERALD_GREEN:
      color = COLOR_CODE.STRONG.EMERALD_GREEN;
      break;
    case COLOR_NAME.STRONG.GRASS_GREEN:
      color = COLOR_CODE.STRONG.GRASS_GREEN;
      break;
    case COLOR_NAME.STRONG.YELLOW_OCHER:
      color = COLOR_CODE.STRONG.YELLOW_OCHER;
      break;
    case COLOR_NAME.STRONG.DEEP_ORANGE:
      color = COLOR_CODE.STRONG.DEEP_ORANGE;
      break;
    case COLOR_NAME.STRONG.CARROT_ORANGE:
      color = COLOR_CODE.STRONG.CARROT_ORANGE;
      break;
    case COLOR_NAME.STRONG.GOLDEN_YELLOW:
      color = COLOR_CODE.STRONG.GOLDEN_YELLOW;
      break;
    case COLOR_NAME.STRONG.FIREBRICK:
      color = COLOR_CODE.STRONG.FIREBRICK;
      break;
    case COLOR_NAME.STRONG.ROSE:
      color = COLOR_CODE.STRONG.ROSE;
      break;
    case COLOR_NAME.STRONG.OLD_ROSE:
      color = COLOR_CODE.STRONG.OLD_ROSE;
      break;
    case COLOR_NAME.STRONG.STRAWBERRY:
      color = COLOR_CODE.STRONG.STRAWBERRY;
      break;
  }
  return color;
}

export default convertColorNameToColorCode;
